// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1uwLb","title":"InfoRow_title__WgTSn"};